<!--begin::Root-->
<div class="d-flex flex-column flex-root">
  <!--begin::Page-->
  <div class="page d-flex flex-column flex-column-fluid">

    <!-- begin:: Loading Bar -->
    <ngx-loading-bar [height]="'4px'"></ngx-loading-bar>
    <!-- end:: Loading Bar -->

    <!--begin::Header-->
    @if (flags?.is_header_enabled) {
    <app-header></app-header>
    }
    <!--end::Header-->
    <!--begin::Container-->
    <div class="flex-column-fluid align-items-stretch container-xxl">
      <!--begin::Wrapper-->
      <div class="wrapper d-flex flex-column flex-row-fluid mt-1">

        <!-- begin: Content height -->
        <div class="min-vh-100">
          <!-- begin: Router content -->
          <router-outlet></router-outlet>
          <!-- end: Router content -->
        </div>
        <!-- end: Content height -->

        <!-- begin: Footer -->
        @if (flags?.is_footer_enabled) {
        <app-footer></app-footer>
        }
        <!-- end: Footer -->
      </div>
      <!--end::Wrapper-->
    </div>
    <!--end::Container-->
  </div>
  <!--end::Page-->
</div>
<!--end::Root-->